import { useEffect, useState } from 'react';
import { syncManager } from '@/offline/syncManager';

/* Estado de conexión y sincronización para la UI */
export const useOfflineSync = () => {
  const [state, setState] = useState(syncManager.getState());

  useEffect(() => {
    syncManager.init();
    const onChange = () => setState(syncManager.getState());
    syncManager.addEventListener('change', onChange);
    return () => syncManager.removeEventListener('change', onChange);
  }, []);

  return { ...state, syncNow: () => syncManager.sync(), refreshPending: () => syncManager.refreshPending() };
};
